import AXIOS from "@/axios";
import axios, { AxiosResponse } from "axios";

export interface LoginResponse {
  message?: string;
  data: {
    token: string;
    username: string;
    role_code: string;
    expires_on: string;
  };
}

export interface LogoutResponse {
  message: string;
}

export interface GetAllRolesResponse {
  id: string;
  name: string;
}

export const loginService = async (username: string, password: string) => {
  return axios.post<AxiosResponse<LoginResponse>>(
    `${import.meta.env.VITE_BASE_URL}/api/auth/v1/login`,
    { username, password }
  );
};

export const logoutService = async () => {
  return AXIOS.get<AxiosResponse<LogoutResponse>>("/auth/v1/logout");
};

export const getAllRolesService = async () => {
  return AXIOS.get<GetAllRolesResponse[]>("/base/dn/v1/role");
};

export const forgotPasswordService = async (email: string) => {
  return AXIOS.post<{ email: string; message: string }>(
    `${import.meta.env.VITE_BASE_URL}/api/auth/v1/forgot-password`,
    { email }
  );
};

export const changePasswordService = async (
  token: string,
  password: string
) => {
  return AXIOS.post<{ message: string }>(
    `${import.meta.env.VITE_BASE_URL}/api/auth/v1/change-password`,
    { encoded_password: password },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );
};
